import React from "react";
import styles from "../../../../styles/AdminConsole.module.css";
import { formatDate } from "../../../../utils/utils";
import Modal from "../../shared/components/Modal";

/**
 * ContactLogViewer
 *
 * Read-only modal showing the full contact log for a lead.
 *
 * Props:
 *   lead     object — lead whose contactLog is being displayed
 *   onClose  () => void
 */
const ContactLogViewer = React.memo(function ContactLogViewer({
  lead,
  onClose,
}) {
  const entries = [...(lead.contactLog || [])].sort(
    (a, b) => (b.date?.seconds || 0) - (a.date?.seconds || 0),
  );

  return (
    <Modal
      title={`Contact Log — ${lead.buyerName}`}
      onClose={onClose}
      maxWidth={520}
    >
      <div style={{ overflowY: "auto", maxHeight: "60vh" }}>
        {entries.length === 0 ? (
          <p
            style={{
              padding: 24,
              textAlign: "center",
              opacity: 0.4,
              fontSize: 12,
            }}
          >
            No log entries yet.
          </p>
        ) : (
          <table className={styles.table}>
            <thead>
              <tr className={styles.tableHeadRow}>
                <th className={styles.th}>#</th>
                <th className={styles.th}>Date</th>
                <th className={styles.th}>Note</th>
              </tr>
            </thead>
            <tbody>
              {entries.map((entry, i) => (
                <tr key={i} className={styles.tableRow}>
                  <td className={styles.td} style={{ opacity: 0.5 }}>
                    {i + 1}
                  </td>
                  <td className={styles.td}>{formatDate(entry.date)}</td>
                  <td className={styles.td}>{entry.note || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </Modal>
  );
});

export default ContactLogViewer;
